'use strict';

bbw.directive.bbwClickConfirm = ['$rootScope', '$fancyModal', function($rootScope, $fancyModal) {

    return {
        link: function(scope, element, attrs) {
            var cb = function() {
                var action = attrs.bbwClickConfirm;
                scope.$evalAsync(action);
                if (!$rootScope.$$phase) {
                    scope.$apply();
                }
            };
            var confirm = function() {
                var scope = $rootScope.$new();
                scope.message = attrs.message;
                scope.header = attrs.header;
                scope.action = attrs.action;
                $fancyModal.open({
                    scope: scope,
                    themeClass: 'confirm',
                    templateUrl: bbw.templateUrl('confirm.html'),
                    controller: ['$scope', function($scope) {
                        $scope.ok = function() {
                            cb();
                            $scope.$modal.close();
                        };
                        $scope.cancel = function() {
                            $scope.$modal.close();
                        };
                    }]
                })
            };
            element.on('click', function($event) {
                $event.preventDefault();
                $event.stopPropagation();
                confirm();
                return false
            });
        }
    }
}];
